import Size from "shared/enums/Size";
import Button from "shared/components/button";
import ToolTip from "shared/components/tooltip";
import { isRegPortal } from "shared/utils/config";
import { useCopies } from "shared/hooks/useCopies";
import { getFormattedCurrency } from "shared/utils";
import PurchaseOrderLines from "../purchaseOrderLines";
import PurchaseOrderTable from "../purchaseOrderTable";
import { useRegDetail } from "shared/context/regDetail";
import { PurchaseOrderDetailsPropTypes } from "../types";

function PurchaseOrderDetails(props: PurchaseOrderDetailsPropTypes) {
  const copies = useCopies();
  const { name: registrationName } = useRegDetail();

  return (
    <div className="paymentSummaryList">
      <div className="paymentSummaryList_header">
        <div className="paymentSummaryList_headerGroup">
          <h3 className="paymentSummaryList_header--title">{props.title || copies.get("summary")}</h3>
          {props.purchaseOrder?.identifier && (
            <p className="paymentSummaryList_header--orderId">
              <span className="paymentSummaryList_header--orderId_label">
                {copies.get("purchase.order.identifier")}
              </span>
              {props.purchaseOrder.identifier}
            </p>
          )}
        </div>

        {isRegPortal && <p className="paymentSummaryList_header--regName">{registrationName}</p>}
      </div>

      <PurchaseOrderLines
        logEvent={props.logEvent}
        lines={props.purchaseOrder.lines}
        showCouponCode={props.showCouponCode}
        editClickHandler={props.editClickHandler}
        originatingFormName={props.originatingFormName}
        applyCouponCodeHandler={props.applyCouponCodeHandler}
        registrationParticipantId={props.registrationParticipantId}
        disableCouponActions={props.purchaseOrder.hasRequestedOfflinePayment || Boolean(props.invoicePayerId)}
      />

      <ul className="paymentSummaryList_footer">
        <li className="paymentSummaryList_grandTotal">
          <div className="paymentSummaryList_grandTotal--details">
            <p className="paymentSummaryList_grandTotal--detailsHeading">{copies.get("total.amount")}</p>
            <ToolTip
              offSetX={-300}
              size={Size.SMALL}
              placement={props.isMobile ? undefined : "bottom"}
              overlayClassName="paymentSummaryList_grandTotal--detailsTooltip"
              content={
                <PurchaseOrderTable
                  isMobile={props.isMobile}
                  title={copies.get("details")}
                  purchaseOrder={props.purchaseOrder}
                  originatingFormName={props.originatingFormName}
                />
              }
              trigger={props.isMobile ? "click" : undefined}>
              <Button.Link label={copies.get("details")} />
            </ToolTip>
          </div>
          <p className="paymentSummaryList_grandTotal--amount">{getFormattedCurrency(props.purchaseOrder?.amount)}</p>
        </li>
      </ul>
    </div>
  );
}

export default PurchaseOrderDetails;
